import APIService from '@/services/APIService.js';

export default {
  upload(postData, onUploadProgress) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60 * 60 * 1000,
      onUploadProgress
    };

    return APIService.apiCall().post('arquivos/upload', postData, config);
  },
  uploadImagem(postData, onUploadProgress) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60 * 60 * 1000,
      onUploadProgress
    };

    return APIService.apiCall().post('arquivos/upload-imagem', postData, config);
  },
  uploadSql(postData, onUploadProgress) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60 * 60 * 1000,
      onUploadProgress
    };

    return APIService.apiCall().post('arquivos/upload-sql', postData, config);
  },
  getByAnoMesGrupo(ano, mes, grupoId) {
    return APIService.apiCall().get(`arquivos/get-by-ano-mes-grupo/${ano}/${mes}/${grupoId}`);
  },
  download(id, onUploadProgress, path = null) {
    const config = {
      responseType: 'blob',
      timeout: 60 * 60 * 1000,
      onUploadProgress
    };

    if (path) config.params = { path };

    return APIService.apiCall().get(`arquivos/download/${id}`, config);
  },
  delete(id) {
    return APIService.apiCall().delete(`arquivos/delete/${id}`);
  }
};
